import { FormStep } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromStepper from '../actions/stepper.action';
import { StateSlice } from '@core/helpers/state-slice';

export type StepperState = StateSlice<FormStep>;

export const initialState: StepperState = {
  data: null,
  loaded: false,
  loading: false,
  error: null,
};

const stepperReducer = createReducer(
  initialState,
  on(fromStepper.updateActiveFormStep, (state, { payload }) => {
    return {
      ...state,
      data: payload,
    };
  })
);

export function reducer(
  state: StepperState | undefined,
  action: fromStepper.StepperActions
) {
  return stepperReducer(state, action);
}
